import { render, staticRenderFns } from "./SearchAddress.vue?vue&type=template&id=1534ec44&scoped=true&"
import script from "./SearchAddress.vue?vue&type=script&lang=js&"
export * from "./SearchAddress.vue?vue&type=script&lang=js&"
import style0 from "./SearchAddress.vue?vue&type=style&index=0&id=1534ec44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1534ec44",
  null
  
)

export default component.exports